import { useMemo } from 'react';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';
import { useSpotMarketsLookup } from './spotMarkets/useSpotMarketsLookup';

const useHighlightedSpotMarkets = () => {
	const spotMarketsLookup = useSpotMarketsLookup();
	const highlightMarketsEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('HIGHLIGHTED_ASSETS')
	);
	const highlightedMarketsFeatureFlagState = useFeatureFlagStore(
		(s) => s.flags.HIGHLIGHTED_ASSETS
	);

	const highlightedSpotMarkets = useMemo(() => {
		if (!highlightMarketsEnabled) return [];

		return highlightedMarketsFeatureFlagState.assets
			.map((assetSymbol) => {
				return spotMarketsLookup.find(
					(market) => market.symbol === assetSymbol
				);
			})
			.filter((market) => !!market); // Filter non-matching markets
	}, [highlightedMarketsFeatureFlagState, highlightMarketsEnabled]);

	return highlightedSpotMarkets;
};

export default useHighlightedSpotMarkets;
